<template>
     <v-list-tile
        v-if="profile"
        :key="profile.name"
        avatar>
        <v-list-tile-avatar>
            <img v-if="profile.picture" :src="profile.picture">
            <v-icon v-else>person</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content :style="width ? `width: ${width}px` : ''">
            <v-list-tile-title v-html="profile.name ? profile.name : 'Guest'"></v-list-tile-title>
            <v-list-tile-sub-title v-html="profile.email"></v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action v-if="icon">
            <v-btn icon @click="$emit('logout')">
                <v-icon>
                    {{ icon }}
                </v-icon>
            </v-btn>
        </v-list-tile-action>
    </v-list-tile>
</template>

<script>
export default {
    props: {
        profile: Object,
        icon: String,
        width: Number
    }
}
</script>


<style>
    .overflow {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
